import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJtiLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 421.27 315.02",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n   .jti-logo-1{fill:#06b085;}\n  " }) }), /* @__PURE__ */ _jsx("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Layer_1-2",
			"data-name": "Layer 1",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "jti-logo-1",
					d: "M31.23,315c-1.74-.83-3.68-.66-5.51-1.1-7.81-1.9-15.1-4.75-20.42-11.14C-.32,296-1.33,288.21,1.6,280.26c2.86-7.76,9.45-11.86,17.29-13.1,12.11-1.91,21.2,3.51,25.64,14.56,1.52,3.77,3,7.58,6,10.51,4.14,4,9.14,3.51,12.14-1.39a21.18,21.18,0,0,0,3-11.18q.05-96.75,0-193.49a7.53,7.53,0,0,0-7.58-7.63c-3.58-.07-7.17,0-10.75,0A11.91,11.91,0,0,1,35.8,69,11.57,11.57,0,0,1,43.68,55.9a18.79,18.79,0,0,1,6.16-.76H150.58c5.63,0,8.29-1.86,10.31-7.19s7.45-8.78,13.86-8.8c8.58,0,17.17,0,25.75,0h133c3.74,0,3.74,0,3.75,3.73q0,8.75,0,17.5c0,3.14,0,3.15-3.26,3.15h-41.5c-7,0-10.75,3.8-10.75,10.81q0,73.25,0,146.49c0,6.36-2.3,11.24-7.9,14.8-15.77,10-31.36,20.29-47,30.45a18,18,0,0,1-3.29,1.75c-6.41,2.46-12.3-1.33-12.79-8.19-.07-.91,0-1.83,0-2.75q0-89.62,0-179.24a34.09,34.09,0,0,0-.31-4.47c-.86-6.47-4.34-9.59-10.86-9.64-7.83-.06-15.67,0-23.5,0-5.34,0-7.68,1.71-9.52,6.69a12.58,12.58,0,0,1-11.92,8.29c-2.42.06-4.83,0-7.25,0a7.45,7.45,0,0,0-7.69,7.5c0,.75,0,1.5,0,2.25q0,72.75,0,145.49a39.74,39.74,0,0,1-7,23.28c-3.55,5.07-8.45,8.69-13.49,12.09-16.52,11.13-33.18,22.07-49.62,33.32-8.28,5.67-17,10.11-26.92,11.84-1.6.28-3.31-.23-4.81.7Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "jti-logo-1",
					d: "M347.23,128.71q0-43.12-.05-86.25c0-2.37.57-3.07,3-3.06q32.87.14,65.75,0c2.27,0,2.72.65,2.72,2.79q-.09,68.37-.06,136.75c0,6.29-2.24,11.27-7.88,14.85-15.91,10.1-31.64,20.48-47.45,30.73a11.52,11.52,0,0,1-5.31,2c-6.13.51-9.71-2.71-10.6-9.58a23.51,23.51,0,0,1-.12-3Q347.23,171.34,347.23,128.71Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "jti-logo-1",
					d: "M382.78,0q13.48,0,27,0a11.25,11.25,0,0,1,11.49,10.51c.46,6.7-3.51,11.69-10,12.57a28,28,0,0,1-3.71.29q-25,0-49.94,0c-4.3,0-8.26-.88-10.9-4.78s-3.11-8.06-1-12.27A10.69,10.69,0,0,1,355.81,0Z"
				})
			]
		})
	})]
});
export default SvgJtiLogo;
